/**
 * @module actions/price
 */
import axios from 'axios'
import {
  API_URL,
  // FILE_STORAGE,
  SET_PRICECALC_PRICES,
  OPEN_POPUP_PARTS,
  SET_CAR_PARTS,
  SET_CAR_PRICEPARTS,
  SET_CAR_SELECTED_PARTS,
  SET_CAR_ITEMS
} from '../constants'

export function resetPrice () {
  return dispatch => {
    dispatch({
      type: SET_PRICECALC_PRICES,
      price: {}
    })
  }
}
export function showPopupParts (show, selectedBodyPart, partSide) {
  return dispatch => {
    dispatch({
      type: OPEN_POPUP_PARTS,
      showPopupForParts: show,
      selectedBodyPart: selectedBodyPart,
      selectedBodyPartSide: partSide
    })
  }
}
export function setCarParts (carParts) {
  return dispatch => {
    dispatch({
      type: SET_CAR_PARTS,
      carParts: carParts
    })
  }
}
export function setCarPriceParts (carPriceParts) {
  return dispatch => {
    dispatch({
      type: SET_CAR_PRICEPARTS,
      carPriceParts: carPriceParts
    })
  }
}
export function setCarSelectedParts (carSelectedParts) {
  return dispatch => {
    dispatch({
      type: SET_CAR_SELECTED_PARTS,
      carSelectedParts: carSelectedParts
    })
  }
}
export function setCarItems (carItems) {
  return dispatch => {
    dispatch({
      type: SET_CAR_ITEMS,
      carItems: carItems
    })
  }
}

export function updateOtherOrderPrice (data) {
  let url = API_URL + '/Order/updateOtherOrderPrice/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/price.js